var collapsible_list_component_rtlignore_default = {
  "ltr": "x8MGj",
  "rtl": "oi5cb",
  "iconContainer": "Mrvso",
  "icon": "jXatU",
  "isExpanded": "wzOc5",
  "listDimensions": "_4ADPP"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
